var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.25C13 13.2033 13 12.68 12.8708 12.2541C12.58 11.2953 11.8297 10.545 10.8709 10.2542C10.445 10.125 9.92167 10.125 8.875 10.125H5.125C4.07833 10.125 3.55499 10.125 3.12914 10.2542C2.17034 10.545 1.42003 11.2953 1.12918 12.2541C1 12.68 1 13.2033 1 14.25M10.375 4.125C10.375 5.98896 8.86396 7.5 7 7.5C5.13604 7.5 3.625 5.98896 3.625 4.125C3.625 2.26104 5.13604 0.75 7 0.75C8.86396 0.75 10.375 2.26104 10.375 4.125Z",
    stroke: "#8D94A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.607e0769f15078982642927ad9e17065.svg";
export { ForwardRef as ReactComponent };